import GridTile from "../model/grid/GridTile";
import BigNum from "../model/math/BigNum";
import Values from "../model/value/Values";

export default class OreCalculationLogic {
    /**
     * 
     * @param {Values} values 
     */
    constructor(values) {
        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {BigNum}
         */
        this.one = new BigNum(1);
    }

    // /**
    //  * The tile MUST be an ORE tile.
    //  * @param {GridTile} tile 
    //  * @param {BigNum} oreOutput
    //  */
    // calculateOre(tile, oreOutput) {
    //     // Only ORE tile types have ore.
    //     if (this.tileType.rarityModifier !== TileTypeRarity.ORE) {
    //         oreOutput.setZero();
    //         return;
    //     }

    //     this.calculateOreForDepth(tile, oreOutput);
    // }

    /**
     * This can be used for tiles that are not ORE tiles.
     * @param {GridTile} tile 
     * @param {BigNum} oreOutput
     */
    calculateOreForDepth(tile, oreOutput) {
        tile.tileType.layerDescription.calculateTileOre(tile.getTileRow(), oreOutput);
        this.applyMultipliers(oreOutput);
    }

    /**
     * @private
     * @param {BigNum} oreOutput
     */
    applyMultipliers(oreOutput) {
        ////////////////////////////////////////////////
        // Check for Ore Bonus
        ////////////////////////////////////////////////

        const oreBonusMultiplier = this.values.skillOreBonusMultiplier.getValue();
        if (oreBonusMultiplier.greaterThan(this.one)) {
            oreOutput.mul(oreBonusMultiplier);
        }
        
        const goldOreBonusMultiplier = this.values.goldOreBonusMultiplier.getValue();
        if (goldOreBonusMultiplier.greaterThan(this.one)) {
            oreOutput.mul(goldOreBonusMultiplier);
        }
    }
}